module.exports = __webpack_public_path__ + "img/32.99c3a95c.jpg";